// EditReportContext.tsx
import React, { createContext, useContext, ReactNode } from "react";

interface EditReportContextType {
    editReportBool: boolean;
    activeEditTab?: number;
    toggle?: (tab: number) => void;
    deckActiveTabBool?: boolean;
    setDeckActiveTab?: (tab: number) => void;
    activeDeckTab?: number;
    setDeckActiveTabBool?: React.Dispatch<React.SetStateAction<boolean>>;
    activeAddLfondsTab?: number;
    setActiveAddLfondsTab?: React.Dispatch<React.SetStateAction<number>>;
    tabsIdListDeck?: Array<number>
    previousDeckTabIndex?: number;
    setPreviousDeckTabIndex?: React.Dispatch<React.SetStateAction<number>>;
    setSaveOrSubmit?: React.Dispatch<React.SetStateAction<boolean>>;
    setDiscardwarning?: React.Dispatch<React.SetStateAction<boolean>>;
    enggActiveTabId?: number;
    setEnggActiveTabId?: React.Dispatch<React.SetStateAction<number>>;
    previousEnggTabIndex?: number;
    setPreviousTabIndex?: React.Dispatch<React.SetStateAction<number>>;
    activeAddEconTab?: number;
    setActiveAddEconTab?: React.Dispatch<React.SetStateAction<number>>;
    tabsIdList?: Array<number>;
    setTabsIdList?: React.Dispatch<React.SetStateAction<Array<number>>>;
    selectedOperations?: Array<number>;
    setSelectedOperations?: React.Dispatch<React.SetStateAction<Array<number>>>;
    activeAddAryaTab?: number;
    setActiveAddAryaTab?: React.Dispatch<React.SetStateAction<number>>;
    discardwarning?: boolean;
    isFirstReport?: boolean;
    toggleTab?: any;
    report?: any;
    toggleDynamicTabs?: any;
    setEditFormRefreshkey?: any;
    setErrorMessage?: any;
}

const EditReportContext = createContext<EditReportContextType | undefined>(undefined);

interface EditReportProviderProps extends EditReportContextType {
    children: ReactNode;
}

export const EditReportProvider = ({
    editReportBool,
    activeEditTab,
    toggle,
    deckActiveTabBool,
    setDeckActiveTab,
    activeDeckTab,
    setDeckActiveTabBool,
    activeAddLfondsTab,
    setActiveAddLfondsTab,
    tabsIdListDeck,
    previousDeckTabIndex,
    setPreviousDeckTabIndex,
    setSaveOrSubmit,
    setDiscardwarning,
    enggActiveTabId,
    setEnggActiveTabId,
    previousEnggTabIndex,
    setPreviousTabIndex,
    activeAddEconTab,
    setActiveAddEconTab,
    tabsIdList,
    setTabsIdList,
    selectedOperations,
    setSelectedOperations,
    children,
    activeAddAryaTab,
    setActiveAddAryaTab,
    discardwarning,
    isFirstReport,
    toggleTab,
    report,
    setEditFormRefreshkey,
    setErrorMessage
}: EditReportProviderProps) => {
    return (
        <EditReportContext.Provider value={{ setSelectedOperations, selectedOperations, setTabsIdList, tabsIdList, activeAddEconTab, setActiveAddEconTab, setPreviousTabIndex, previousEnggTabIndex, setEnggActiveTabId, editReportBool, activeEditTab, toggle, deckActiveTabBool, setDeckActiveTab, activeDeckTab, setDeckActiveTabBool, activeAddLfondsTab, setActiveAddLfondsTab, tabsIdListDeck, previousDeckTabIndex, setPreviousDeckTabIndex, setSaveOrSubmit, setDiscardwarning, enggActiveTabId, discardwarning, activeAddAryaTab, setActiveAddAryaTab, isFirstReport, toggleTab, report, setEditFormRefreshkey, setErrorMessage }}>
            {children}
        </EditReportContext.Provider>
    );
};

export const useEditReport = () => {
    const ctx = useContext(EditReportContext);
    if (!ctx) throw new Error("useEditReport must be used inside EditReportProvider");
    return ctx;
};
